import {
  SOP_SICKNESS_LEAVE_ABOUT_YOU_STEP,
  SOP_SICKNESS_LEAVE_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapFromCommerceSopSicknessLeave(data: {
  [key: string]: any;
}): FormStates {
  const { coverageGroup, revenue, dailyPayoutAmount } = data;

  return {
    [SOP_SICKNESS_LEAVE_ABOUT_YOU_STEP.id]: {
      pep: BooleanFormType.FALSE,
      revenue: revenue,
      dailyPayoutAmount: dailyPayoutAmount,
    },
    [SOP_SICKNESS_LEAVE_PRICE_STEP.id]: {
      coverage: coverageGroup,
      dailyPayoutAmount: dailyPayoutAmount,
    },
  };
}
